import React from "react";
import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { View } from "@/styles/reactnative";

const MarketTrendTabs = ({ tab, setTab, tabs }) => {
  return (
    <View
      style={{
        flexDirection: "row",
        background: "#E9EDF2",
        padding: 3,
        borderRadius: 3,
      }}
    >
      {tabs.map((item: any, index: any) => (
        <CButton
          key={index.toString()}
          title={item?.toUpperCase()}
          onClick={() => {
            setTab(item);
          }}
          style={{
            color: COLORS.lightGray5,
            fontWeight: "500",
            paddingBlock: 3,
            paddingInline: 8,
            backgroundColor: tab === item ? COLORS.white : undefined,
          }}
          backgroundHover={COLORS.lightGray3}
        />
      ))}
    </View>
  );
};

export default React.memo(MarketTrendTabs);
